import Vue from 'vue'
import moment from 'moment'
import numeral from 'numeral'

const DEFAULT_DATE_PATTERN = 'll'
const FROM_NOW_MARKER = 'fromNow'

const SIGNED_PERCENTAGE_PATTERN = '+0.00%'
const PERCENTAGE_PATTERN = '0.00%'

Vue.filter('date', (value, pattern) => {
  if (pattern === FROM_NOW_MARKER) {
    return value && moment.utc(value).local().fromNow()
  } else {
    return value && moment.utc(value).local().format(pattern || DEFAULT_DATE_PATTERN)
  }
})

Vue.filter('percentage', (value, sign) => {
  return numeral(value).format(sign ? SIGNED_PERCENTAGE_PATTERN : PERCENTAGE_PATTERN)
})
